export const DAO_CODE = 'SUBSIDIARY' + '_DAO';
